import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=7c7386d3"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports